import { useRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Tile, ShareSocials } from '../components'
import { ReactComponent as ArrowRight } from '../assets/arrow-slide-right.svg'
import { ReactComponent as ArrowLeft } from '../assets/arrow-slide-left.svg'
import 'swiper/css'
import style from './block.module.scss'

const MoreArticle = ({ articles }) => {
    const { t } = useTranslation()
    const swiperRef = useRef(null)
    const [active, setActive] = useState(0)
    const isMobile = useMediaQuery('(max-width:' + style.mobileBreakpoint + ')')
    const isTablet = useMediaQuery('(max-width:' + style.tabletBreakpoint + ')')
    const socialsBreakpoint = useMediaQuery('(max-width: 1450px)')
    const perView = isMobile ? 1 : isTablet ? 2 : 3
    const swiperOptions = {
        loop: true,
        slidesPerView: perView,
        spaceBetween: 26,
        modules: [Navigation],
        className: style.swiper,
    }

    const handlePrev = () => {
        if (!swiperRef.current) return
        swiperRef.current.swiper.slidePrev()
    }

    const handleNext = () => {
        if (!swiperRef.current) return
        swiperRef.current.swiper.slideNext()
    }
    const updateIndex = () => {
        setActive(swiperRef.current.swiper.realIndex)
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            swiperRef.current.swiper.slideToLoop(0)
        }, 100)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div className={style.block}>
            {socialsBreakpoint && <ShareSocials positionStyle={style.socials} />}
            <h3>{t('Articles associés')}</h3>
            <Swiper {...swiperOptions} ref={swiperRef} onRealIndexChange={updateIndex}>
                {Object.values(articles).map((article, i) => {
                    return (
                        <SwiperSlide className={style.slideContainer} key={article.link}>
                            <Tile article={article} />
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            <div className={style.pagination}>
                <div className={style.line} />
                <div className={style.row}>
                    <div className={style.arrows}>
                        <div className={style.arrow} onClick={handlePrev}>
                            <ArrowLeft />
                        </div>
                        <div className={style.arrow} onClick={handleNext}>
                            <ArrowRight />
                        </div>
                    </div>
                    <div className={style.center}>
                        <div className={style.number}>
                            {active + 1}/{articles.length}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MoreArticle
